import { ensureSafeComponent } from '@embroider/util';
import { importSync } from '@embroider/macros';
import { service } from '@ember/service';
import Route from '@ember/routing/route';

export default class SitePaymentLinkRoute extends Route {
  @service router;
  @service session;
  @service store;
  @service fastboot;
  @service currentPractice;
  @service analytics;

  model(params) {
    if (this.fastboot.isFastBoot) {
      return;
    }
    if (!this.isFeatureFlagEnabled) {
      return this.router.transitionTo('not-found', 'errors/404');
    }
    return this.store.adapterFor('payment-link').queryRecord(params.uuid, { reload: true });
  }

  beforeModel(transition) {
    this.session.requireAuthentication(transition, 'home');
  }

  afterModel(model, transition) {
    if (transition.from?.name === 'sign-in.token.verify' && model.status === 'active')
      this.trackPaymentLinkSignIn(model);
  }

  get isFeatureFlagEnabled() {
    return this.currentPractice.get('featurePaymentLinks');
  }

  setupController(controller, model) {
    super.setupController(...arguments);

    let component;
    switch (model.status) {
      case 'active':
        component = 'payment-link/payment-form';
        break;
      case 'paid':
        component = 'payment-link/paid';
        break;
      case 'expired':
        component = 'payment-link/expired';
        break;
    }

    const module = importSync(`../../components/site/${component}`);

    controller.set('containerComponent', ensureSafeComponent(module.default, this));
  }

  trackPaymentLinkSignIn(model) {
    // eslint-disable-next-line camelcase
    this.analytics.track('Payment Link Clicked', { payment_link_id: model.uuid });
  }
}
